import { render } from "./PublicMeetingRegistration.vue?vue&type=template&id=746f70ba&scoped=true"
import script from "./PublicMeetingRegistration.vue?vue&type=script&lang=js"
export * from "./PublicMeetingRegistration.vue?vue&type=script&lang=js"

import "./PublicMeetingRegistration.vue?vue&type=style&index=0&id=746f70ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746f70ba"]])

export default __exports__